// extracted by mini-css-extract-plugin
export default {"root":"FilterItem_root__iYgdz","dark":"FilterItem_dark__rDGPs","more":"FilterItem_more__KsqSi"};